import React, { useEffect, useRef, useState, useMemo } from "react";
import Isotope from "isotope-layout";
import ProjectDetailsModal from "./ProjectDetailsModal";

// Hook personalizado para detectar mobile
const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  return isMobile;
};

const Portfolio = ({ classicHeader, darkTheme }) => {
  // init one ref to store the future isotope object
  const isotope = useRef();
  // store the filter keyword in a state
  const [filterKey, setFilterKey] = useState("*");
  const [imagesLoaded, setimagesLoaded] = useState(0);
  const [selectedProjectDetails, setSelectedProjectDetails] = useState();
  
  // State for website status checking - DISABLED to prevent CORS errors
  // const [siteStatuses, setSiteStatuses] = useState({});
  // const [statusLoading, setStatusLoading] = useState({});

  const filters = {
    INSTITUTIONAL: "Institutional",
    HEALTH: "Healthcare",
    ELEARNING: "E-Learning",
    LANDING: "Landing Pages",
    SERVICES: "Services",
    MULTILANGUAGE: "Multilanguage",
    PORTFOLIO: "Portfolio",
    REALESTATE: "Real Estate & Law",
    ECOMMERCE: "E-Commerce",
    ONEPAGE: "One Page",
    BLOG: "Blog & News",
  };

  // Function to check website status - DISABLED to avoid CORS errors
  const checkSiteStatus = async (url, siteId) => {
    // Disabled site status checks to prevent CORS errors in console
    return;
    /*
    if (!url || siteStatuses[siteId] !== undefined || statusLoading[siteId]) {
      return;
    }

    setStatusLoading(prev => ({ ...prev, [siteId]: true }));
    
    try {
      // Using a CORS proxy service for client-side requests
      const corsProxy = 'https://api.allorigins.win/get?url=';
      const response = await fetch(corsProxy + encodeURIComponent(url), {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      
      const data = await response.json();
      
      // Check if the proxy was able to fetch the site
      const isOnline = response.ok && data.status && data.status.http_code < 400;
      
      setSiteStatuses(prev => ({
        ...prev,
        [siteId]: isOnline ? 'online' : 'offline'
      }));
      
    } catch (error) {
      // Site check failed, continue silently
      setSiteStatuses(prev => ({
        ...prev,
        [siteId]: 'offline'
      }));
    } finally {
      setStatusLoading(prev => ({ ...prev, [siteId]: false }));
    }
    */
  };

  // Function to get status indicator - DISABLED to prevent CORS errors
  const getStatusIndicator = (url, siteId) => {
    // Disabled site status indicators to prevent CORS errors
    return null;
    /*
    if (!url) return null;
    
    const status = siteStatuses[siteId];
    const loading = statusLoading[siteId];
    
    if (loading) {
      return (
        <span 
          className="ms-2 badge bg-secondary" 
          title="Verificando estado..."
          style={{ fontSize: '10px' }}
        >
          <i className="fas fa-spinner fa-spin"></i>
        </span>
      );
    }
    
    if (status === 'online') {
      return (
        <span 
          className="ms-2 badge bg-success" 
          title="Sitio en línea"
          style={{ fontSize: '10px' }}
        >
          <i className="fas fa-circle"></i>
        </span>
      );
    }
    
    if (status === 'offline') {
      return (
        <span 
          className="ms-2 badge bg-danger" 
          title="Sitio fuera de línea o inaccesible"
          style={{ fontSize: '10px' }}
        >
          <i className="fas fa-circle"></i>
        </span>
      );
    }
    
    return null;
    */
  };

  const projectsData = [
    // INSTITUTIONAL - HEALTH - ORG - E-LEARNING
    {
      id: "policing-lab",
      title: "Policing Lab",
      projectInfo: "Research and policy organization focused on policing and criminal justice reform.",
      client: "Roar Media",
      clientLink: "https://roarmedia.com",
      clientFlag: "🇺🇸",
      technologies: "WordPress, PHP, JavaScript, CSS3",
      industry: "Research & Policy",
      date: "2024",
      url: {
        name: "policinglab.org",
        link: "https://policinglab.org/",
      },
      thumbImage: "/images/projects/policing-portfolio.webp",
      sliderImages: [
        "/images/projects/project-1.jpg",
        "/images/projects/project-2.jpg",
      ],
      categories: [filters.INSTITUTIONAL],
    },
    {
      title: "SAVE Cursos",
      projectInfo: "E-learning platform for the 4th edition of specialized medical courses. This comprehensive educational platform hosts the fourth iteration of our advanced medical training program, featuring interactive modules and certification pathways.",
      client: "Aquí y Aurora 🇦🇷",
      clientLink: "http://aquiyaurora.com.ar/",
      technologies: "WordPress, LearnPress, PHP, JavaScript, CSS3",
      industry: "Education & Health", 
      date: "2025",
      url: {
        name: "cursos.save.org.ar",
        link: "https://cursos.save.org.ar/",
      },
      thumbImage: "/images/projects/save-portfolio.webp",
      sliderImages: [
        "/images/projects/save-portfolio.webp",
        "/images/projects/save-video.mp4",
      ],
      categories: [filters.ELEARNING, filters.HEALTH],
    },
    {
      title: "SAVE Argentina",
      projectInfo: "Argentine Society of Vaccinology and Epidemiology main website.",
      client: "SAVE Argentina",
      technologies: "WordPress, PHP, MySQL",
      industry: "Health Organization",
      date: "2024",
      url: {
        name: "save.org.ar",
        link: "https://save.org.ar/",
      },
      thumbImage: "/images/projects/project-3.jpg",
      sliderImages: [
        "/images/projects/project-3.jpg",
        "/images/projects/project-4.jpg",
      ],
      categories: [filters.INSTITUTIONAL, filters.HEALTH],
    },
    {
      title: "Confianza en las Vacunas",
      projectInfo: "Comprehensive vaccine confidence platform for Latin America, providing evidence-based information and resources to combat vaccine hesitancy. Features interactive content, educational materials, and multilingual support to promote public health awareness.",
      client: "Aquí y Aurora 🇦🇷",
      clientLink: "http://aquiyaurora.com.ar/",
      technologies: "WordPress, HTML5, CSS3, JavaScript",
      industry: "Health",
      date: "2021",
      url: {
        name: "confianzaenlasvacunasla.org",
        link: "http://confianzaenlasvacunasla.org/",
      },
      thumbImage: "/images/projects/cvla-portfolio.webp",
      sliderImages: [
        "/images/projects/cvla-portfolio.webp",
        "/images/projects/cvla-video.mp4",
      ],
      categories: [filters.HEALTH],
    },
    {
      title: "Tu Plan Antigripal",
      projectInfo: "Flu prevention campaign and information platform.",
      client: "Health Campaign",
      technologies: "WordPress, Campaign Management",
      industry: "Health",
      date: "2024",
      url: {
        name: "tuplanantigripe.com.ar",
        link: "https://www.tuplanantigripe.com.ar/",
      },
      thumbImage: "/images/projects/project-5.jpg",
      sliderImages: [
        "/images/projects/project-5.jpg",
        "/images/projects/project-1.jpg",
      ],
      categories: [filters.INSTITUTIONAL, filters.HEALTH],
    },
    {
      title: "Fundación BNA",
      projectInfo: "Banco Nación Argentina Foundation website.",
      client: "Fundación BNA",
      technologies: "WordPress, Corporate Design",
      industry: "Financial Foundation",
      date: "2024",
      url: {
        name: "fundacionbna.org.ar",
        link: "https://fundacionbna.org.ar/",
      },
      thumbImage: "/images/projects/project-6.jpg",
      sliderImages: [
        "/images/projects/project-6.jpg",
        "/images/projects/project-7.jpg",
      ],
      categories: [filters.INSTITUTIONAL],
    },
    {
      title: "CONFEDI",
      projectInfo: "Federal Council of Engineering Deans of Argentina.",
      client: "CONFEDI",
      technologies: "WordPress, Educational Platform",
      industry: "Education",
      date: "2024",
      url: {
        name: "confedi.org.ar",
        link: "https://confedi.org.ar/",
      },
      thumbImage: "/images/projects/project-7.jpg",
      sliderImages: [
        "/images/projects/project-7.jpg",
        "/images/projects/project-1.jpg",
      ],
      categories: [filters.INSTITUTIONAL],
    },
    {
      title: "Habla Diabetes",
      projectInfo: "Diabetes awareness and education platform.",
      client: "Health Education",
      technologies: "WordPress, Interactive Content",
      industry: "Health",
      date: "2024",
      url: {
        name: "habladiabetes.com.ar",
        link: "https://habladiabetes.com.ar/",
      },
      thumbImage: "/images/projects/project-1.jpg",
      sliderImages: [
        "/images/projects/project-1.jpg",
        "/images/projects/project-2.jpg",
      ],
      categories: [filters.INSTITUTIONAL, filters.HEALTH, filters.ELEARNING],
    },

    // LANDING PAGES
    {
      title: "Ofertas Claras",
      projectInfo: "Clear offers landing page for promotional campaigns.",
      client: "Marketing Agency",
      technologies: "HTML5, CSS3, JavaScript",
      industry: "Marketing",
      date: "2024",
      url: {
        name: "ofertasclaras.com",
        link: "https://ofertasclaras.com/",
      },
      thumbImage: "/images/projects/project-2.jpg",
      sliderImages: [
        "/images/projects/project-2.jpg",
        "/images/projects/project-3.jpg",
      ],
      categories: [filters.LANDING],
    },
    {
      title: "SAVE Gripe 2021",
      projectInfo: "Flu campaign landing page 2021.",
      client: "SAVE Argentina",
      technologies: "WordPress, Campaign Landing",
      industry: "Health Campaign",
      date: "2021",
      url: {
        name: "save.org.ar/gripe2021",
        link: "https://save.org.ar/gripe2021/",
      },
      thumbImage: "/images/projects/project-3.jpg",
      sliderImages: [
        "/images/projects/project-3.jpg",
        "/images/projects/project-4.jpg",
      ],
      categories: [filters.LANDING],
    },

    // INSTITUTIONAL - SERVICES
    {
      title: "Reef Haven Belize",
      projectInfo: "Belize reef conservation and tourism services.",
      client: "Reef Haven",
      technologies: "WordPress, Tourism Integration",
      industry: "Tourism & Conservation",
      date: "2024",
      url: {
        name: "reefhavenbelize.com",
        link: "https://reefhavenbelize.com/",
      },
      thumbImage: "/images/projects/project-4.jpg",
      sliderImages: [
        "/images/projects/project-4.jpg",
        "/images/projects/project-5.jpg",
      ],
      categories: [filters.INSTITUTIONAL, filters.SERVICES],
    },
    {
      title: "Estudio FH",
      projectInfo: "Legal and consulting services firm website.",
      client: "Estudio FH",
      technologies: "WordPress, Professional Services",
      industry: "Legal Services",
      date: "2024",
      url: {
        name: "estudiofh.com.ar",
        link: "https://estudiofh.com.ar/",
      },
      thumbImage: "/images/projects/project-5.jpg",
      sliderImages: [
        "/images/projects/project-5.jpg",
        "/images/projects/project-6.jpg",
      ],
      categories: [filters.INSTITUTIONAL, filters.SERVICES],
    },
    {
      title: "Carica Consulting",
      projectInfo: "Business consulting and advisory services.",
      client: "Carica Inc",
      technologies: "WordPress, Business Solutions",
      industry: "Consulting",
      date: "2024",
      url: {
        name: "caricapinc.com",
        link: "http://caricapinc.com/",
      },
      thumbImage: "/images/projects/project-6.jpg",
      sliderImages: [
        "/images/projects/project-6.jpg",
        "/images/projects/project-7.jpg",
      ],
      categories: [filters.INSTITUTIONAL, filters.SERVICES],
    },

    // MULTILANGUAGE
    {
      title: "ACTIA Dimensiona",
      projectInfo: "Multilingual auction platform offering secure bidding services across multiple markets. This comprehensive platform features real-time auction management, multi-currency support, and automated bidding systems designed for international markets.",
      client: "Dimensiona 🇪🇸",
      clientLink: "https://dimensiona.com/",
      technologies: "WordPress, WPML, PHP",
      industry: "Automotive",
      date: "2021",
      url: {
        name: "actia.dimensiona.com",
        link: "http://actia.dimensiona.com/",
      },
      thumbImage: "/images/projects/actia-cover.jpg",
      sliderImages: [
        "/images/projects/actia-desktop.jpg",
        "/images/projects/actia-video.mp4",
      ],
      categories: [filters.ONEPAGE, filters.MULTILANGUAGE],
    },
    {
      title: "Cimarron Cine",
      projectInfo: "Multilingual cinema and entertainment platform.",
      client: "Cimarron Cine",
      technologies: "WordPress, WPML, Video Integration",
      industry: "Entertainment",
      date: "2024",
      url: {
        name: "cimarroncine.com",
        link: "https://cimarroncine.com/",
      },
      thumbImage: "/images/projects/project-7.jpg",
      sliderImages: [
        "/images/projects/project-7.jpg",
        "/images/projects/project-1.jpg",
      ],
      categories: [filters.MULTILANGUAGE],
    },

    // PORTFOLIO
    {
      title: "Via Vento Canning",
      projectInfo: "Real estate portfolio and property showcase.",
      client: "Via Vento",
      technologies: "WordPress, Property Showcase",
      industry: "Real Estate",
      date: "2024",
      url: {
        name: "viaventocanning.com.ar",
        link: "http://viaventocanning.com.ar",
      },
      thumbImage: "/images/projects/project-1.jpg",
      sliderImages: [
        "/images/projects/project-1.jpg",
        "/images/projects/project-2.jpg",
      ],
      categories: [filters.PORTFOLIO],
    },
    {
      title: "Rebecca Furniture",
      projectInfo: "Furniture design portfolio and showcase.",
      client: "Rebecca Furniture",
      technologies: "WordPress, Portfolio Design",
      industry: "Interior Design",
      date: "2024",
      url: {
        name: "rebeccafurniture.com.ar",
        link: "https://rebeccafurniture.com.ar",
      },
      thumbImage: "/images/projects/project-2.jpg",
      sliderImages: [
        "/images/projects/project-2.jpg",
        "/images/projects/project-3.jpg",
      ],
      categories: [filters.PORTFOLIO],
    },

    // REAL ESTATE / LAW
    {
      title: "FIDJ Law",
      projectInfo: "International law firm specializing in real estate.",
      client: "FIDJ Law",
      technologies: "WordPress, Legal Platform",
      industry: "Legal Services",
      date: "2024",
      url: {
        name: "fidjlaw.com",
        link: "https://fidjlaw.com/",
      },
      thumbImage: "/images/projects/project-3.jpg",
      sliderImages: [
        "/images/projects/project-3.jpg",
        "/images/projects/project-4.jpg",
      ],
      categories: [filters.REALESTATE],
    },
    {
      title: "Trief & Olk",
      projectInfo: "Real estate and law firm services.",
      client: "Roar Media 🇺🇸",
      clientLink: "https://roarmedia.com.ar/",
      technologies: "WordPress, Professional Services",
      industry: "Real Estate & Law",
      date: "2022",
      url: {
        name: "triefandolk.com",
        link: "https://www.triefandolk.com/",
      },
      thumbVideoImage: "/images/projects/trief-cover.jpg",
      projectVideo: "/images/projects/trief-porfolio.mp4",
      thumbImage: "/images/projects/trief-cover.jpg",
      sliderImages: [
        "/images/projects/trief-desktop.png",
        "/images/projects/trief-video.mp4",
      ],
      categories: [filters.INSTITUTIONAL, filters.REALESTATE],
    },

    // E-COMMERCE
    {
      title: "Bokenkin",
      projectInfo: "Modern e-commerce platform featuring cutting-edge design and seamless user experience. Built with advanced Shopify Liquid templating and optimized for performance, this platform showcases innovative product presentation and streamlined checkout processes using custom Liquid code.",
      client: "Roar Media",
      clientLink: "https://roarmedia.com.ar/",
      technologies: "Shopify, Liquid, JavaScript, CSS3",
      industry: "E-commerce",
      date: "2025",
      url: {
        name: "bokenkin.com",
        link: "https://bokenkin.com/",
      },
      thumbImage: "/images/projects/bokenkin-porfolio.webp",
      sliderImages: [
        "/images/projects/bokenkin-porfolio.webp",
        "/images/projects/bokenkin-video.mp4",
      ],
      categories: [filters.ECOMMERCE],
    },
    {
      title: "Pushkar",
      projectInfo: "Online store for artisanal and handcrafted products.",
      client: "Pushkar",
      technologies: "WooCommerce, JS, HTML, CSS3",
      industry: "Crafts & Art",
      date: "2020",
      url: {
        name: "pushkar.com.ar",
        link: "https://pushkar.com.ar/",
      },
      thumbImage: "/images/projects/pushkar-cover.jpg",
      sliderImages: [
        "/images/projects/pushkar-cover.jpg",
        "/images/projects/pushkar-video.mp4",
      ],
      categories: [filters.ECOMMERCE],
    },
    {
      title: "BAIRES Grow",
      projectInfo: "Specialized e-commerce platform for cannabis cultivation supplies and premium seeds. Features comprehensive product catalog, cultivation guides, and educational resources for both recreational and medicinal cannabis growing enthusiasts.",
      client: "BAIRES Grow",
      technologies: "WooCommerce, PHP, JavaScript, HTML5, CSS3",
      industry: "Cannabis",
      date: "2025",
      url: {
        name: "bairesgrow.com.ar",
        link: "https://bairesgrow.com.ar/",
      },
      thumbImage: "/images/projects/baires-portfolio.webp",
      sliderImages: [
        "/images/projects/baires-portfolio.webp",
        "/images/projects/bairesgrow-video.mp4",
      ],
      categories: [filters.ECOMMERCE],
    },
    {
      title: "AVL-112",
      projectInfo: "Electronics and technology e-commerce platform.",
      client: "Aquí y Aurora 🇦🇷",
      clientLink: "http://aquiyaurora.com.ar/",
      technologies: "WooCommerce, Electronics Catalog",
      industry: "Electronics",
      date: "2020",
      url: {
        name: "avl112.com.ar",
        link: "https://avl112.com.ar/",
      },
      thumbVideoImage: "/images/projects/avl112-cover.jpg",
      projectVideo: "/images/projects/avl112-porfolio.mp4",
      thumbImage: "/images/projects/avl112-cover.jpg",
      sliderImages: [
        "/images/projects/avl112-desktop.jpg",
        "/images/projects/avl112-video.mp4",
      ],
      categories: [filters.ECOMMERCE],
    },

    // ONE PAGE
    {
      title: "IF-SA Financial",
      projectInfo: "Corporate one-page website for financial services.",
      client: "IF-SA",
      technologies: "HTML5, CSS3, JavaScript",
      industry: "Financial Services",
      date: "2024",
      url: {
        name: "if-sa.com.ar",
        link: "https://if-sa.com.ar/",
      },
      thumbImage: "/images/projects/project-6.jpg",
      sliderImages: [
        "/images/projects/project-6.jpg",
        "/images/projects/project-7.jpg",
      ],
      categories: [filters.ONEPAGE],
    },
    {
      title: "Hetermicas",
      projectInfo: "Single page website for thermal services company.",
      client: "Hetermicas",
      technologies: "HTML5, CSS3, Contact Forms",
      industry: "Industrial Services",
      date: "2024",
      url: {
        name: "hetermicas.com.ar",
        link: "https://hetermicas.com.ar/",
      },
      thumbImage: "/images/projects/project-7.jpg",
      sliderImages: [
        "/images/projects/project-7.jpg",
        "/images/projects/project-1.jpg",
      ],
      categories: [filters.ONEPAGE],
    },

    // BLOG / NEWS
    {
      title: "ICL Digital",
      projectInfo: "Digital marketing blog and news platform.",
      client: "ICL Digital",
      technologies: "WordPress, Blog Theme, SEO",
      industry: "Digital Marketing",
      date: "2024",
      url: {
        name: "icldigital.com.ar",
        link: "https://icldigital.com.ar/",
      },
      thumbImage: "/images/projects/project-1.jpg",
      sliderImages: [
        "/images/projects/project-1.jpg",
        "/images/projects/project-2.jpg",
      ],
      categories: [filters.BLOG],
    },
  ];

  // Use useMemo to avoid recalculating selected projects
  const selectedProjectsForGrid = useMemo(() => {
    const selected = [
      projectsData.find(p => p.title === "Policing Lab"),
      projectsData.find(p => p.title === "BAIRES Grow"),
      projectsData.find(p => p.title === "AVL-112"), 
      projectsData.find(p => p.title === "SAVE Cursos"),
      projectsData.find(p => p.title === "Pushkar"),
      projectsData.find(p => p.title === "ACTIA Dimensiona"),
      projectsData.find(p => p.title === "Bokenkin"),
      projectsData.find(p => p.title === "Confianza en las Vacunas"),
    ].filter(Boolean);
    
    return selected.length > 0 ? selected : projectsData.slice(0, 8);
  }, []);

  // Use useMemo for grid categories
  const gridCategories = useMemo(() => {
    return [...new Set(
      selectedProjectsForGrid.flatMap(p => p.categories || [])
    )];
  }, [selectedProjectsForGrid]);

  // Create grid filters object
  const gridFilters = useMemo(() => {
    const filters_obj = {};
    Object.keys(filters).forEach(key => {
      if (gridCategories.includes(filters[key])) {
        filters_obj[key] = filters[key];
      }
    });
    return filters_obj;
  }, [gridCategories]);

  // Hook para detectar mobile
  const isMobile = useIsMobile();

  // State management con lógica mobile/desktop
  const [visibleCount, setVisibleCount] = useState(() => isMobile ? 2 : 6);
  const [listFilterKey, setListFilterKey] = useState("*");

  // Ajustar visibleCount cuando cambie el tamaño de pantalla
  useEffect(() => {
    if (isMobile && visibleCount > 2 && visibleCount < 6) {
      // Mantener la lógica mobile si ya se han cargado más proyectos
      return;
    }
    
    if (isMobile && visibleCount === 6) {
      setVisibleCount(2);
      // En mobile, siempre mostrar todos los proyectos (sin filtros)
      setFilterKey("*");
    } else if (!isMobile && visibleCount === 2) {
      setVisibleCount(6);
    }
  }, [isMobile]);
  
  // Extended projects for grid display
  const extendedProjects = useMemo(() => {
    return selectedProjectsForGrid;
  }, [selectedProjectsForGrid]);

  // initialize an Isotope object with configs after projects are ready
  useEffect(() => {
    if (selectedProjectsForGrid.length > 0) {
      // Small delay to ensure DOM is ready - más tiempo para mobile
      const timer = setTimeout(() => {
        if (document.querySelector(".portfolio-filter")) {
          // Destruir isotope anterior si existe
          if (isotope.current) {
            isotope.current.destroy();
          }
          
          isotope.current = new Isotope(".portfolio-filter", {
            itemSelector: ".filter-item",
            layoutMode: isMobile ? "fitRows" : "masonry",
            transitionDuration: isMobile ? "0.3s" : "0.6s",
          });
          
          // Aplicar filtro actual después de la inicialización
          if (filterKey !== "*") {
            setTimeout(() => {
              const filter = `.${filterKey.replace(/\s+/g, '-').toLowerCase()}`;
              isotope.current.arrange({ filter });
              isotope.current.layout();
            }, 100);
          }
        }
      }, isMobile ? 200 : 100);

      return () => {
        clearTimeout(timer);
        if (isotope.current) {
          isotope.current.destroy();
        }
      };
    }
  }, [selectedProjectsForGrid.length, isMobile]); // Agregar isMobile como dependencia

  // handling filter key change
  useEffect(() => {
    if (imagesLoaded > 0 && isotope.current) {
      const filter = filterKey === "*" ? "*" : `.${filterKey.replace(/\s+/g, '-').toLowerCase()}`;
      isotope.current.arrange({ filter });
      isotope.current.layout();
    }
  }, [filterKey, imagesLoaded]);

  const handleFilterKeyChange = (key) => () => {
    // Solo permitir filtros en desktop
    if (!isMobile) {
      setFilterKey(key);
    }
  };

  return (
    <>
      <section
        id="portfolio"
        className={"section " + (darkTheme ? "bg-dark-1" : "")}
      >
        <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
          {/* Heading */}
          <div className="position-relative d-flex text-center mb-5">
            <h2
              className={
                "text-24  text-uppercase fw-600 w-100 mb-0 " +
                (darkTheme ? "text-muted opacity-1" : "text-light opacity-4")
              }
            >
              Portfolio
            </h2>
            <p
              className={
                "text-9 text-dark fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
                (darkTheme ? "text-white" : "text-dark")
              }
            >
              {" "}
              My Work
              <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
            </p>
          </div>
          {/* Heading end*/}
          {/* Filter Menu - Solo en desktop */}
          {!isMobile && (
            <ul
              className={
                "portfolio-menu nav nav-tabs justify-content-center border-bottom-0 mb-5 " +
                (darkTheme ? "nav-light" : "")
              }
            >
              <li className="nav-item">
                <button
                  className={"nav-link " + (filterKey === "*" ? "active" : "")}
                  onClick={handleFilterKeyChange("*")}
                >
                  All
                </button>
              </li>
              {Object.keys(gridFilters).map((oneKey, i) => (
                <li className="nav-item" key={i}>
                  <button
                    className={
                      "nav-link " +
                      (filterKey === gridFilters[oneKey] ? "active" : "")
                    }
                    onClick={handleFilterKeyChange(gridFilters[oneKey])}
                  >
                    {gridFilters[oneKey]}
                  </button>
                </li>
              ))}
            </ul>
          )}
          {/* Filter Menu end */}
          <div className="portfolio popup-ajax-gallery">
            <div className="row portfolio-filter filter-container g-4">
              {extendedProjects.length > 0 &&
                extendedProjects.slice(0, visibleCount).map((project, index) => (
                  <div
                    className={
                      "col-sm-6 col-lg-4 filter-item " +
                      (project.categories || []).map(cat => cat.replace(/\s+/g, '-').toLowerCase()).join(" ")
                    }
                    key={index}
                  >
                    <div className="portfolio-box rounded">
                      <div className="portfolio-img rounded">
                        <img
                          onLoad={() => {
                            setimagesLoaded(imagesLoaded + 1);
                          }}
                          className="img-fluid d-block portfolio-image"
                          src={project.thumbImage}
                          alt=""
                        />
                        <div className="portfolio-overlay">
                          <button
                            type="button"
                            className="popup-ajax stretched-link btn btn-link p-0 border-0 bg-transparent w-100 h-100 position-absolute"
                            onClick={() => {
                              setSelectedProjectDetails(project);
                            }}
                            data-bs-toggle="modal"
                            data-bs-target="#exampleModal"
                            aria-label={`Ver detalles de ${project.title}`}
                            style={{top: 0, left: 0}}
                          >
                            <span className="visually-hidden">Ver proyecto {project.title}</span>
                          </button>
                          <div className="portfolio-overlay-details">
                            <h5 className="text-white fw-400">
                              {project.title}
                            </h5>
                            <span className="text-light mt-2 d-block">{project.categories}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
            {/* Buttons under grid */}
            <div className="col-12 text-center mt-4">
              {visibleCount < Math.min(isMobile ? 9 : 12, extendedProjects.length) ? (
                <div>
                  <button
                    className="btn btn-outline-primary rounded-pill shadow-none mb-2"
                    onClick={() => {
                      const increment = isMobile ? 2 : 6;
                      const maxProjects = isMobile ? 9 : 12;
                      const next = Math.min(visibleCount + increment, Math.min(maxProjects, extendedProjects.length));
                      setVisibleCount(next);
                      setTimeout(() => {
                        if (isotope.current) {
                          isotope.current.reloadItems();
                          isotope.current.arrange();
                        }
                      }, 300);
                    }}
                  >
                    View more projects
                  </button>
                  <div>
                    <button type="button" className="btn btn-link text-primary p-0" data-bs-toggle="modal" data-bs-target="#projectsListModal" onClick={() => setListFilterKey("*")}>
                      Full Projects list
                    </button>
                  </div>
                </div>
              ) : (
                <div>
                  <button type="button" className="btn btn-link text-primary p-0" data-bs-toggle="modal" data-bs-target="#projectsListModal" onClick={() => setListFilterKey("*")}>
                    Full Projects list
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Projects List Modal */}
        <div
          className="modal fade"
          id="projectsListModal"
          tabIndex={-1}
          aria-labelledby="projectsListModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="projectsListModalLabel">Projects List</h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div className="modal-body">
                <div className="mb-3 d-flex justify-content-center">
                  <div className="category-scroll-container" style={{overflowX: 'auto', paddingBottom: '10px'}}>
                    <ul className={"portfolio-menu nav nav-tabs border-bottom-0 mb-3 justify-content-center " + (darkTheme ? "nav-light" : "")} style={{flexWrap: 'nowrap', minWidth: 'max-content'}}> 
                      <li className="nav-item">
                        <button className={"nav-link " + (listFilterKey === "*" ? "active" : "")} onClick={() => setListFilterKey("*")}>All</button>
                      </li>
                      {Object.keys(filters).map((oneKey, i) => (
                        <li className="nav-item" key={i}>
                          <button className={"nav-link " + (listFilterKey === filters[oneKey] ? "active" : "")} onClick={() => setListFilterKey(filters[oneKey])}>
                            {filters[oneKey]}
                          </button>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                
                <style>{`
                  .category-scroll-container {
                    scrollbar-width: thin;
                    scrollbar-color: #007bff #f1f1f1;
                  }
                  
                  .category-scroll-container::-webkit-scrollbar {
                    height: 12px;
                    display: block !important;
                  }
                  
                  .category-scroll-container::-webkit-scrollbar-track {
                    background: #f1f1f1;
                    border-radius: 6px;
                    margin: 0 10px;
                  }
                  
                  .category-scroll-container::-webkit-scrollbar-thumb {
                    background: linear-gradient(90deg, #007bff, #0056b3);
                    border-radius: 6px;
                    border: 1px solid #e9ecef;
                    min-width: 30px;
                  }
                  
                  .category-scroll-container::-webkit-scrollbar-thumb:hover {
                    background: linear-gradient(90deg, #0056b3, #004085);
                    box-shadow: 0 2px 4px rgba(0,123,255,0.3);
                  }
                  
                  .category-scroll-container::-webkit-scrollbar-corner {
                    background: #f1f1f1;
                  }
                  
                  /* Forzar visibilidad del scroll */
                  .category-scroll-container {
                    overflow-x: scroll !important;
                  }
                `}</style>
                <ul className="list-unstyled" key={listFilterKey}>
                  {projectsData
                    .filter((p) => {
                      if (listFilterKey === "*") return true;
                      return p.categories && p.categories.indexOf(listFilterKey) !== -1;
                    })
                    .map((p, idx) => {
                      const siteId = `site_${idx}_${p.title.replace(/\s+/g, '_')}`;
                      
                      // Site status checking disabled to prevent CORS errors
                      // if (p.url && p.url.link && siteStatuses[siteId] === undefined && !statusLoading[siteId]) {
                      //   setTimeout(() => checkSiteStatus(p.url.link, siteId), idx * 200); // Stagger requests
                      // }
                      
                      return (
                        <li key={`${listFilterKey}-${idx}`} className="mb-2 d-flex align-items-center">
                          <div className="flex-grow-1">
                            {p.url && p.url.link ? (
                              <a href={p.url.link} target="_blank" rel="noopener noreferrer">
                                {p.title} 
                                <small className="text-muted">({p.url.name || p.url.link})</small>
                              </a>
                            ) : (
                              <span>{p.title}</span>
                            )}
                          </div>
                          {p.url && p.url.link && getStatusIndicator(p.url.link, siteId)}
                        </li>
                      );
                    })}
                </ul>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-success" data-bs-dismiss="modal">Close</button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="project-details-modal">
        {/* Modal */}
        <ProjectDetailsModal
          projectDetails={selectedProjectDetails}
          darkTheme={darkTheme}
        ></ProjectDetailsModal>
      </div>
    </>
  );
};

export default Portfolio;
